import { UsaStates } from 'usa-states';

function getStatesList() {
	return new UsaStates().states?.map((e) => {
		return { label: e.name, value: e.abbreviation };
	});
}

export { getStatesList };
